export default "/images/book.png?bee9047da433377f0a478b654be9a0f8";